export default {
  settingsLoading: false,
  settings: []
}
